const createSimpleSelectOptions = (labels) => {
  return labels.reduce((result, label) => {
    result[label] = { label, value: label };
    return result;
  }, {});
};
export {
  createSimpleSelectOptions
};
//# sourceMappingURL=create-simple-select.js.map
